import { rusRegExp, isSafe } from 'uikit'

export const validRussianWord = word => {
  if (word === '' || !isSafe(word)) return null
  if (!rusRegExp.test(word)) return 'Только кириллица'

  return null
}
